import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

const Toggles = props => {
  const { t } = useTranslation()
  const buttons = [t('One way'), t('Round trip'), t('Multiple destinations')]
  const handleClick = index => e => {
    e.preventDefault()
    if (props.onItemClick) {
      props.onItemClick(index)
    }
  }
  return (
    <ul className='toggles'>
      {buttons.map((title, i) => (
        <li
          className={classnames([
            'toggles__item',
            { 'toggles__item--active': i === props.activeIndex },
          ])}
          key={title}
        >
          <a className='toggles__link' href='#' onClick={handleClick(i)}>
            {title}
          </a>
        </li>
      ))}
    </ul>
  )
}

Toggles.propTypes = {
  activeIndex: PropTypes.number,
  onItemClick: PropTypes.func,
}

export default Toggles
